import { oneSiam } from "./one-siam"

//prevent from removing " " from non "xxx-xxx" pattern.
// prettier-ignore
export const extensionConfigs = {
  "one-siam": oneSiam,
}
